import React, { useCallback } from 'react';
import styles from './UIGameTradeCreatorActionButtons.module.scss';
import IconTradeOpponentsCheck from '@static/images/icon_trade_opponents_check.svg';
import { UIGameActionButton } from '../../../common/UIGameActionButton/index.ts';
import { T } from '@colonist/ui';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { ACTION_BUTTON_IDS } from '../../UIGameActionButtonsContainer/utils.ts';
import { useCurrentStateValidator } from '../../../store/selectors/useCurrentStateValidator.ts';
import { ActionState } from '@colonist/game-states';
export const UIGameTradeCreatorActionButtonTradeWithOpponents = ({ tradeCreationDataValidator, getCurrentTradeCreationData, hideTooltip })=>{
    var _tradeWithOpponentsError_payload;
    const onClickCreateTrade = useGameStore((state)=>state.gameTrade.onClickCreateTrade);
    const setTradeError = useGameStore((state)=>state.gameTrade.setTradeError);
    const isSomePlayerSelectingToDiscard = useCurrentStateValidator().isSomePlayerInActionState(ActionState.SelectCardsToDiscard);
    const tradeCreationData = getCurrentTradeCreationData(false);
    const tradeWithOpponentsError = isSomePlayerSelectingToDiscard ? {
        error: {
            key: 'strings:game.errors.playersDiscarding'
        },
        payload: {
            isPlayerTradeButtonDisabled: true
        }
    } : tradeCreationDataValidator.getTradeCreationDataError(tradeCreationData);
    const hasTradeError = tradeWithOpponentsError != undefined;
    const isButtonDisabled = (tradeWithOpponentsError === null || tradeWithOpponentsError === void 0 ? void 0 : (_tradeWithOpponentsError_payload = tradeWithOpponentsError.payload) === null || _tradeWithOpponentsError_payload === void 0 ? void 0 : _tradeWithOpponentsError_payload.isPlayerTradeButtonDisabled) == true;
    const helperText = tradeWithOpponentsError === null || tradeWithOpponentsError === void 0 ? void 0 : tradeWithOpponentsError.error;
    const handleErrorOnClick = useCallback(()=>{
        if (tradeWithOpponentsError != null) {
            var _tradeWithOpponentsError_payload;
            const tradeError = {
                error: tradeWithOpponentsError.error
            };
            if (((_tradeWithOpponentsError_payload = tradeWithOpponentsError.payload) === null || _tradeWithOpponentsError_payload === void 0 ? void 0 : _tradeWithOpponentsError_payload.highlightCards) != null) {
                tradeError.payload = {
                    highlightCards: tradeWithOpponentsError.payload.highlightCards
                };
            }
            setTradeError(tradeError);
        }
    }, [
        tradeWithOpponentsError
    ]);
    const handleTradeWithOpponentsClick = useCallback(()=>{
        if (hasTradeError) {
            handleErrorOnClick();
            return;
        }
        onClickCreateTrade(tradeCreationData);
    }, [
        hasTradeError,
        tradeCreationData,
        handleErrorOnClick
    ]);
    return /*#__PURE__*/ React.createElement(UIGameActionButton, {
        id: ACTION_BUTTON_IDS.tradePlayers,
        onClick: handleTradeWithOpponentsClick,
        onClickActionIfDisabled: handleErrorOnClick,
        className: styles.actionButton,
        iconClassName: styles.icon,
        iconPath: IconTradeOpponentsCheck,
        tooltipTitle: hideTooltip ? undefined : /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.tradeWithOpponents"
        }),
        shakingAnimation: hasTradeError,
        disabled: isButtonDisabled,
        helperText: helperText
    });
};
